import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import { Link } from 'react-router-dom';

// components
import Grid from '@material-ui/core/Grid';
// import Breadcrumbs from '@material-ui/core/Breadcrumbs';
// import Container from '@material-ui/core/Container';
// import Modal from '@material-ui/core/Modal';
// import AddEditEvent from './components/AddEditEvent';
import Typography from 'components/shared/Typography';
import { useLocation } from 'react-router-dom';
// import LoadingButton from 'components/shared/LoadingButton';
// import Calendar from './components/Calendar';
// import CircularProgress from '@material-ui/core/CircularProgress';
import { Container } from '@mui/material';
import { SPACING_THIRD, SPACING, SPACING_HALF } from 'constants/spacing';
import RectangularGrid from 'components/shared/RectangularGrid';
import { Link } from '@material-ui/core';
import SelectBranch from './components/SelectBranch';
import SelectService from './components/SelectService';
import SelectDateTime from './components/SelectDateTime';
import OrderSummary from './components/OrderSummary';
import SuccessfulPayment from './components/SuccessfulPayment';
import FailedPayment from './components/FailedPayment';

// hooks
// import { useAllEvents, useCreateEvent, useUpdateEvent } from 'hooks/event';
// import { useDivisionValue } from 'providers/DivisionProvider';

// utils
// import { arrayUniqueKey } from 'utils';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // minHeight: '100vh',
    minHeight: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftPanel: {
    width: '100%',
    // minHeight: '100vh',
    minHeight: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  form: {
    width: '100%',
  },
  buttonWraper: {
    marginTop: theme.spacing(SPACING),
  },
  monkey: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  phoneInput: {
    '& .MuiInputBase-input::placeholder': {
      textAlign: 'center',
    },
    '& .MuiInputBase-input': {
      textAlign: 'right',
      direction: 'rtl',
    },
  },
  largeLabel: {
    marginTop: 35,
    fontSize: theme.typography.pxToRem(25),
    height: '75%',
    '&:disabled':{
      color: '#959595'
    }
  },
  wholepage: {
    // width: '100vw',
    // height: '100vh',
    // backgroundColor: '#e5e5e5',
  },
  mainContainer: {
    // backgroundColor: '#f5f5f5',
    // borderRadius:"10px",
    position: 'relative',
    top: 'calc((100% - 650px) /2)',
    padding: '0px',
    height:"650px",

    [theme.breakpoints.down('xs')]: {
      // backgroundColor: '#e5e5e5',
      top: '0',
    },
  },
  branchCard: {
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: '#D2D2D2',
    borderRadius: '20px',

    [theme.breakpoints.down('xs')]: {
      // marginBottom:"10px",
      margin: '3%',
    },
  },
  branchCardSelected: {
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: '#24AF6E',
    backgroundColor: '#f1f7f5',
    borderRadius: '20px',

    [theme.breakpoints.down('xs')]: {
      // marginBottom:"10px",
      margin: '3%',
    },
  },
}));

const branches_data = [
  {
    _id: '1',
    title: 'شعبه مرکزی',
    titleID: 'شعبه مرکزی',
    address: 'اشرفی اصفهانی',
    image: 'https://fs.shegeftangizan.com/elmaassets/clinic.png',
  },
];

const steps = ["selectBranch","selectService","selectDateTime","paymentInfo","paymentStatus"]

function CustomerOrders() {
  const classes = useStyles();

  const location = useLocation();
  let service = {
    "_id": "6684032ce201de000995c690",
    "title": "مشاوره تخصصی",
    "price": 2000000,
    "duration": 10,
    "deposit": 1000000,
    "division": {
        "members": [
            "6651bfc6183178a26a7e00eb"
        ],
        "internal": false,
        "showForCustomer": true,
        "_id": "6651c40ce201de000995c548",
        "branch": "شعبه مرکزی",
        "title": "شعبه مرکزی - مشاوره زیبایی",
        "__v": 0
    }
}
  const initialState = {selectedService:service,setSelectedTime:"",currentStep:2, ...location.state};

  const [selectedBranch, setSelectedBranch] = useState(branches_data[0]);
  const [selectedService, setSelectedService] = useState(initialState.selectedService);
  const [selectedTime, setSelectedTime] = useState(initialState.selectedTime)
  const [currentStep, setCurrentStep] = useState(initialState.currentStep);
  const nextStep = ()=>{
    setCurrentStep(currentStep+1)
  }
  const prevStep = () =>{
    setCurrentStep(currentStep-1)
  }
  useEffect(()=>{
    console.log("currentStep:",currentStep)
  },[currentStep])

  useEffect(()=>{
    console.log("selectedTime has been set...",selectedTime)
  },[selectedTime])
  return (
    <div className={classes.wholepage}>
      <Container maxWidth="md"  className={classes.mainContainer}>
        {/* {currentStep===0 && <SelectBranch selectedBranch={selectedBranch} setSelectedBranch={setSelectedBranch} branches_data={branches_data} nextStep={nextStep}></SelectBranch>} */}
        {/* {currentStep===1 && <SelectService selectedBranch={selectedBranch} selectedService={selectedService} setSelectedService={setSelectedService} nextStep={nextStep} prevStep={prevStep}></SelectService>} */}
        {currentStep===2 && <SelectDateTime selectedService={selectedService} selectedTime={selectedTime} setSelectedTime={setSelectedTime} nextStep={nextStep} prevStep={prevStep}></SelectDateTime>}
        {currentStep===3 && <OrderSummary selectedService={selectedService} selectedTime={selectedTime} nextStep={nextStep} prevStep={prevStep}></OrderSummary>}
        {currentStep===4.1 && <SuccessfulPayment> </SuccessfulPayment>}
        {currentStep===4.2 && <FailedPayment> </FailedPayment>}
        
      </Container>
    </div>
  );
}

export default CustomerOrders;
